import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { useRecoilValue } from "recoil";
import { getRecoil } from "recoil-nexus";
import styled from "styled-components";
import SoundControl from "../../../components/SoundControl";
import OrderController, {
  OrderStatusType,
} from "../../../controller/OrderController";
import PrinterController from "../../../controller/PrinterController";
import {
  CurrentStoreType,
  authState,
  currentStoreState,
} from "../../../recoil/auth";
import { THROO_ORDER_STATE_COLOR, ThrooOrderType } from "../../../recoil/type";
import {
  getThrooOrderCurrentStatus,
  getThrooOrderNextStatus,
} from "../../../utils/StatusComment";

interface OrderProps {
  props: any;
  isBlink: boolean;
  setBlinkCount: any;
}

const minuteList: any = [];
for (let i = 3; i < 19; i++) {
  minuteList.push({
    key: i,
    value: i * 5,
    name: i > 1 ? `${i * 5}분` : `0${i * 5}분`,
    label: i > 1 ? `${i * 5}분` : `0${i * 5}분`,
  });
}

const ButtonStatus = ({ props, isBlink, setBlinkCount }: OrderProps) => {
  const oThrooOrder: ThrooOrderType = props.order;
  const currentStore = useRecoilValue<CurrentStoreType>(currentStoreState);

  const [pickupTimeModal, setPickupTimeModal] = useState<boolean>(false);
  const [deliveryStatus, setDeliveryStatus] = useState<number>(
    oThrooOrder.state_color === THROO_ORDER_STATE_COLOR.CONCLUDE ? 3 : 0
  );

  const [remainTime, setRemainTime] = useState<number>(
    oThrooOrder.state_color === THROO_ORDER_STATE_COLOR.STANDBY
      ? Math.floor(
          (new Date(oThrooOrder.order_created_at).getTime() -
            new Date().getTime() +
            oThrooOrder.arrival_in_minutes * 1000 * 60) /
            (60 * 1000)
        )
      : Math.floor(
          (new Date(oThrooOrder.arrival_time!).getTime() -
            new Date().getTime()) /
            (60 * 1000)
        )
  );
  const [completeDifferTime, setCompleteDifferTime] = useState<number>(
    Math.floor(
      (new Date(oThrooOrder.arrival_time!).getTime() -
        new Date(oThrooOrder.arrival_time!).getTime()) /
        (60 * 1000)
    )
  );

  const [minute, setMinute] = useState<any>({
    key: -1,
    value: oThrooOrder.arrival_time,
    name: `${oThrooOrder.arrival_in_minutes_show}`,
    label: `${oThrooOrder.arrival_in_minutes_show}`,
  });

  const onChange_status = () => {
    if (oThrooOrder.state_color === THROO_ORDER_STATE_COLOR.STANDBY)
      setPickupTimeModal(true);
    else if (
      oThrooOrder.state_color === THROO_ORDER_STATE_COLOR.CONCLUDE ||
      oThrooOrder.state_color === THROO_ORDER_STATE_COLOR.CUSTOMER_CANCELLED ||
      oThrooOrder.state_color === THROO_ORDER_STATE_COLOR.STORE_CANCELLED
    ) {
    } else updateStatus();
  };

  const onChange_minute = (event: any) => {
    setMinute(event);
  };

  const isDisabledStatusButton = () => {
    if (
      oThrooOrder.state_id === 17001 ||
      oThrooOrder.state_id === 18001 ||
      oThrooOrder.state_id === 15002
    ) {
      if (
        oThrooOrder.state_color === THROO_ORDER_STATE_COLOR.CONCLUDE ||
        oThrooOrder.state_color ===
          THROO_ORDER_STATE_COLOR.CUSTOMER_CANCELLED ||
        oThrooOrder.state_color === THROO_ORDER_STATE_COLOR.STORE_CANCELLED
      )
        return true;
      else return false;
    } else {
      return false;
    }
  };

  // orderStatus API
  const updateStatus = async (clickedTime?: number) => {
    const oParams: OrderStatusType = {
      order_id: props.order_id,
      order_seq: 0,
      order_status: oThrooOrder.state_id,
      // oThrooOrder.next_order_status === -1
      //   ? 0
      //   : oThrooOrder.next_order_status, // test
      delivery_estimated_time: clickedTime ? clickedTime : minute.value,
      table_area_nr: props.table_area_nr,
      table_nr: props.table_nr,
      store_id: props.store_id,
      parent_store_id: props.parent_store_id,
      user_token_id: getRecoil(authState).user_token_id,
      status_changed_at: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    };
    if (clickedTime)
      oParams.expected_at = moment(
        new Date(new Date().getTime() + clickedTime * 60 * 1000)
      ).format("YYYY-MM-DD HH:mm:ss");

    //return;
    // console.log("oParams", oParams);
    const oRes = await OrderController.updateStatus(oParams);

    if (oRes && oRes.data) {
      // setRecoil(checkOrderState, new Date().getTime().toString());
      if (oThrooOrder.state_color === THROO_ORDER_STATE_COLOR.CONCLUDE) {
        // setRecoil(completeOrderState, {
        //   date: new Date().getTime().toString(),
        //   order_status: oThrooOrder.next_order_status,
        // });
        setBlinkCount(0);
        // SoundControl.playSoundOnce();
        // setRecoil(deliveryState, new Date().getTime().toString());
      } else {
        // setRecoil(notCompleteOrderState, {
        //   date: new Date().getTime().toString(),
        //   order_status: oThrooOrder.next_order_status,
        // });
        setBlinkCount(3);
        if (oThrooOrder.state_color === THROO_ORDER_STATE_COLOR.STANDBY) {
          PrinterController.preparePrintData(props, 1, true, true);
        }
      }

      console.log("oRes", oRes);
    }
  };

  useEffect(() => {
    setMinute({
      key: -1,
      value: oThrooOrder.arrival_time,
      name: `${oThrooOrder.arrival_in_minutes_show}`,
      label: `${oThrooOrder.arrival_in_minutes_show}`,
    });
  }, [oThrooOrder.arrival_time]);

  useEffect(() => {
    if (
      currentStore &&
      currentStore.value?.auto_confirmed === 1 &&
      oThrooOrder.state_color === THROO_ORDER_STATE_COLOR.STANDBY
    ) {
      updateStatus(oThrooOrder.arrival_in_minutes);
    }
  }, []);

  useEffect(() => {
    let interval: NodeJS.Timeout;
    /*
    setRemainTime(
      poThrooOrder.state_color === THROO_ORDER_STATE_COLOR.STANDBY
        ? Math.floor(
            (new Date(oThrooOrder.ordered_at).getTime() -
              new Date().getTime() +
              oThrooOrder.delivery_estimated_time * 1000 * 60) /
              (60 * 1000)
          )
        : Math.floor(
            (new Date(oThrooOrder.delivery_expected_at!).getTime() -
              new Date().getTime()) /
              (60 * 1000)
          )
    );
    if (
      oThrooOrder.state_color === ORDER_COM_DEL_STATUS ||
      oThrooOrder.state_color === ORDER_COM_STATUS
    ) {
      setCompleteDifferTime(
        Math.floor(
          (new Date(oThrooOrder.delivery_completed_at!).getTime() -
            new Date(oThrooOrder.delivery_expected_at!).getTime()) /
            (60 * 1000)
        )
      );
    }

    interval = setInterval(() => {
      setRemainTime(
        oThrooOrder.state_color === THROO_ORDER_STATE_COLOR.STANDBY
          ? Math.floor(
              (new Date(oThrooOrder.ordered_at).getTime() -
                new Date().getTime() +
                oThrooOrder.delivery_estimated_time * 1000 * 60) /
                (60 * 1000)
            )
          : Math.floor(
              (new Date(oThrooOrder.delivery_expected_at!).getTime() -
                new Date().getTime()) /
                (60 * 1000)
            )
      );
      if (
        oThrooOrder.state_color === ORDER_COM_DEL_STATUS ||
        oThrooOrder.state_color === ORDER_COM_STATUS
      ) {
        setCompleteDifferTime(
          Math.floor(
            (new Date(oThrooOrder.delivery_completed_at!).getTime() -
              new Date(oThrooOrder.delivery_expected_at!).getTime()) /
              (60 * 1000)
          )
        );
      }
      // console.log("timer", remainTime, completeDifferTime);
    }, 1000);
    */

    return () => {
      //clearInterval(interval);
    };
  }, [oThrooOrder.state_color]);

  useEffect(() => {
    if (oThrooOrder.app_name === "THROO") {
      if (oThrooOrder.state_color === THROO_ORDER_STATE_COLOR.CONFIRMED) {
        setDeliveryStatus(1);
      } else if (oThrooOrder.state_color === THROO_ORDER_STATE_COLOR.PREPARED) {
        setDeliveryStatus(2);
      } else if (oThrooOrder.state_color === THROO_ORDER_STATE_COLOR.CONCLUDE) {
        setDeliveryStatus(3);
      } else {
        setDeliveryStatus(0);
      }
    }
  }, [oThrooOrder.state_color]);

  // 배달 정보
  const DeliveryStatusButton = useMemo(() => {
    return (
      <div className="circleWrap">
        <div
          className="donut"
          style={{
            background: `conic-gradient(#4dd2ae 0% ${
              deliveryStatus * (100 / 3)
            }%, #efefef ${deliveryStatus * (100 / 3)}% 100%)`,
          }}
        >
          {oThrooOrder.state_color ===
            THROO_ORDER_STATE_COLOR.CUSTOMER_CANCELLED ||
          oThrooOrder.state_color ===
            THROO_ORDER_STATE_COLOR.STORE_CANCELLED ? (
            <div className="circleContent cancel">
              <h3 className={`cancel`}>결제취소</h3>
            </div>
          ) : (
            <div className="circleContent">
              <h3 className={`delivery`}>
                {getThrooOrderCurrentStatus(
                  oThrooOrder.app_name,
                  oThrooOrder.state_color
                )}
              </h3>
              {deliveryStatus === 0 && (
                <div className="loadingDots">
                  <div className="dot" />
                  <div className="dot" />
                  <div className="dot" />
                  <div className="dot" />
                </div>
              )}
              {deliveryStatus === 3 ? (
                <div>
                  <h5 className="completeTime">
                    {moment(new Date(oThrooOrder.picked_up_at!)).format(
                      "HH:mm"
                    )}
                  </h5>
                  <h5
                    className={`${
                      completeDifferTime > 0
                        ? "plus"
                        : completeDifferTime === 0
                        ? "completeTime"
                        : "minus"
                    }`}
                  >
                    {completeDifferTime >= 0 ? "+" : ""}
                    {completeDifferTime}분
                  </h5>
                </div>
              ) : (
                <h5 className={`delivery ${remainTime < 0 && "plus"}`}>
                  {remainTime < 0
                    ? `${Math.abs(remainTime)}분 초과`
                    : `${Math.abs(remainTime)}분 남음`}
                </h5>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }, [
    oThrooOrder.state_color,
    oThrooOrder.order_created_at,
    oThrooOrder.arrival_time,
    oThrooOrder.prepare_in_seconds,
    remainTime,
    completeDifferTime,
    deliveryStatus,
  ]);

  // 주문 정보 버튼
  const OrderStatusButton = useMemo(() => {
    return (
      <div
        className={`buttonContainer delivery
        ${isDisabledStatusButton() && "disabled"}  ${isBlink && "notCheck"} ${
          (oThrooOrder.state_color ===
            THROO_ORDER_STATE_COLOR.CUSTOMER_CANCELLED ||
            oThrooOrder.state_color ===
              THROO_ORDER_STATE_COLOR.STORE_CANCELLED) &&
          "cancel"
        }`}
      >
        <div className="buttonWrap" onClick={onChange_status}>
          <h3>
            {getThrooOrderNextStatus(
              oThrooOrder.app_name,
              oThrooOrder.state_color
            )}
          </h3>
          {(oThrooOrder.state_color ===
            THROO_ORDER_STATE_COLOR.CUSTOMER_CANCELLED ||
            oThrooOrder.state_color ===
              THROO_ORDER_STATE_COLOR.STORE_CANCELLED) && (
            <h4 className="cancel">{/*oThrooOrder.cancel_description*/}</h4>
          )}
        </div>
      </div>
    );
  }, [
    isBlink,
    oThrooOrder.state_color,
    oThrooOrder.prepare_in_seconds,
    deliveryStatus,
  ]);

  return (
    <>
      <Style>
        <div className="listRight">
          {/* 배달 정보 */}
          {DeliveryStatusButton}
          {/* 주문정보 버튼 */}
          {OrderStatusButton}
        </div>
      </Style>
    </>
  );
};

export default ButtonStatus;

const Style = styled.div`
  /* 줄임말 공통 */
  h4.info {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  /* text공통 */
  h1 {
    font-size: 32px;
    color: #333333;
    line-height: 36px;
    font-weight: 600;
    margin-bottom: 4px;
  }
  h2 {
    font-size: 24px;
    line-height: 28px;
    color: #333333;
    font-weight: 600;
    white-space: nowrap;
  }
  h2.orderType {
    padding-top: 26px;
    padding-bottom: 4px;
    color: #4dd2ae;
  }
  h4 {
    color: #333333;
    font-weight: 400;
  }
  p {
    font-size: 12px;
    line-height: 14px;
    font-weight: 400;
    color: #999999;
  }

  .listRight {
    min-width: 280px;
    width: 280px;
    display: flex;
    gap: 10px !important;
    justify-content: flex-end;

    .circleWrap {
      padding: 10px;
      width: 150px;
      height: 150px;

      @keyframes rotateGradient {
        0% {
          background-position: 0% 0%;
        }
        100% {
          background-position: 100% 100%;
        }
      }

      .donut {
        position: relative;
        width: 100%;
        aspect-ratio: 1/1;
        margin: 0 auto;
        border-radius: 50%;
        position: relative;
        text-align: center;
      }
      .circleContent {
        position: absolute;
        width: 85%;
        aspect-ratio: 1/1;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 50%;
        background: #ffffff;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 25%;
        z-index: 1;

        h3 {
          font-weight: 600;
        }
        h5 {
          padding-top: 6px;
          font-weight: 500;
        }
        h5.completeTime {
          color: #999999;
        }
        h5.plus {
          color: #ff3542;
        }
        h5.minus {
          color: #000000;
        }

        .loadingDots {
          display: flex;
          align-items: center;
          justify-content: center;
          padding-top: 6px;
          gap: 12px;

          @keyframes changeColor {
            0% {
              background: #4dd2ae;
            }
            50% {
              background: #d1d1d1;
            }
          }
          .dot {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: #d1d1d1;
            animation: changeColor 2s infinite;
          }
          .dot:nth-child(2) {
            animation-delay: 0.5s;
          }
          .dot:nth-child(3) {
            animation-delay: 1s;
          }
          .dot:nth-child(4) {
            animation-delay: 1.5s;
          }
        }
      }
    }
    .circleContent.cancel {
      padding-top: calc(100% / 3);
    }

    .buttonContainer {
      position: relative;
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      width: 120px;
      height: 150px;
      outline: none;
      box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.25);
      cursor: pointer;
      h3 {
        color: #ffffff;
        font-weight: 600;
      }

      .buttonWrap {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        white-space: pre-line;
        position: relative;

        h4 {
          margin-bottom: -20px;
          line-height: 50px;
          color: #ffffff;
        }
        h4.cancel {
          position: absolute;
          top: 100px;
          font-size: 14px;
          line-height: 18px;
          color: #ff3542;
        }
      }
    }
    .buttonContainer.delivery {
      background: #4dd2ae;
      border: 1px solid #4dd2ae;
    }
    .buttonContainer.throo {
      background: #5991ff;
      border: 1px solid #5991ff;
    }
    .buttonContainer.packing {
      background: #fd7441;
      border: 1px solid #fd7441;
    }
    .buttonContainer.delivery.notCheck {
      background: #dffff6;
      h3 {
        color: #4dd2ae;
      }
    }
    .buttonContainer.throo.notCheck {
      background: #dffff6;
      h3 {
        color: #4dd2ae;
      }
    }
    .buttonContainer.packing.notCheck {
      background: #dffff6;
      h3 {
        color: #4dd2ae;
      }
    }
    .buttonContainer.disabled {
      cursor: default;
      background: #b2b2b2;
      border: 1px solid #b2b2b2;
      box-shadow: none;
    }
    .buttonContainer.disabled.notCheck {
      background: #f0f0f0;
      h3 {
        color: #b2b2b2;
      }
    }
    .buttonContainer.cancel {
      cursor: default;
      border: 1px solid #ff3542;
      background: #ffffff;
      h3 {
        color: #ff3542;
      }
    }

    .timeSelectBox {
      width: 100%;
    }
    .statusDetailText {
      padding: 11px 10px;
      border-bottom-right-radius: 5px;
      border-bottom-left-radius: 5px;
      text-align: center;
      font-size: 14px;
      line-height: 20px;
      color: #fff;
      font-weight: 500;
      white-space: nowrap;
    }
  }
`;
